module.exports = __webpack_public_path__ + "img/logo_facebook.da89d7e1.png";